import { get, post, del } from "@/utils/https";
import store from "@/store";

// 贷款用途
export function loanUseEnums() {
  return get(`/api/v1/common/cus/infra/hq/dic/loan-purpose`);
}

// 行业
export function industryEnums() {
  return get(`/api/v1/common/cus/infra/hq/dic/industry`);
}

// 行驶证修改
export function licenseUpdate(data) {
  return post(
    `/api/v1/common/cus/apply/hq/save/ocr-driving-licence/${data.prePlatOrderNo}`,
    data
  );
}

// 信息查询 - 行驶证
export function licenseInfo(prePlatOrderNo) {
  return get(
    `/api/v1/common/cus/apply/hq/ocr-driving-licence/${prePlatOrderNo}`
  );
}

// 信息查询 - 身份证
export function idcardInfo(prePlatOrderNo) {
  return get(`/api/v1/common/cus/apply/hq/ocr/idcard/${prePlatOrderNo}`);
}

// 申请订单创建
export function applyCreate(data) {
  return post(`/api/v1/common/cus/apply/hq/apply`, data);
}

// 银行预留手机号验证码
export function authSmsCode(data) {
  return get(`/api/v1/common/cus/apply/hq/apply/${data.mobile}`, data);
}

// 人脸对比
export function faceCompare({ prePlatOrderNo, url }) {
  if (!prePlatOrderNo) throw "预进件订单号错误";
  return post(`/api/v1/common/cus/apply/hq/face/idcard/${prePlatOrderNo}`, {
    url
  });
}

// ocr识别
export function ocrIdentify(data) {
  const productInfo = store.state.productInfo;
  const { merchantNo } = productInfo;
  const { prePlatOrderNo } = store.state.userOrderInfo;
  data.prePlatOrderNo = prePlatOrderNo;
  data.merchantNo = merchantNo;
  return post(`/api/v1/common/cus/apply/hq/ocr/idcard`, data);
}

// ocr营业执照识别
export function ocrLicence(data) {
  const productInfo = store.state.productInfo;
  const { merchantNo } = productInfo;
  const { prePlatOrderNo } = store.state.userOrderInfo;
  data.prePlatOrderNo = prePlatOrderNo;
  data.merchantNo = merchantNo;
  return post(`/api/v1/common/cus/apply/hq/ocr/licence`, data);
}

// ocr银行卡
export function ocrBankCard(data) {
  const productInfo = store.state.productInfo;
  const { merchantNo } = productInfo;
  const { prePlatOrderNo } = store.state.userOrderInfo;
  data.prePlatOrderNo = prePlatOrderNo;
  data.merchantNo = merchantNo;
  return post(`/api/v1/common/cus/apply/hq/support/ocr/bank-card`, data);
}

// ocr行驶证
export function ocrLicense(data) {
  if (!data.prePlatOrderNo) throw "预进件订单号错误";
  const productInfo = store.state.productInfo;
  const { merchantNo } = productInfo;
  const { prePlatOrderNo } = store.state.userOrderInfo;
  data.prePlatOrderNo = prePlatOrderNo;
  data.merchantNo = merchantNo;
  return post(
    `/api/v1/common/cus/apply/hq/ocr-driving-licence/${data.prePlatOrderNo}`,
    data
  );
}

// 识别提交认证
export function ocrIdentifySubmit(data) {
  if (!data.prePlatOrderNo) throw "订单号错误";
  return post(
    `/api/v1/common/cus/apply/hq/ocr/idcard/${data.prePlatOrderNo}`,
    data
  );
}

// 列表
export function orderList(data) {
  return post(`/api/v1/common/cus/apply/hq/apply/list`, data);
}

// 订单详情
export function orderDetailInfo(bizNo) {
  if (!bizNo) throw "订单号错误";
  return get(`/api/v1/common/cus/apply/hq/${bizNo}`);
}

// 创建个人信息
export function createCustomerInfo(data) {
  return post(`/api/v1/common/cus/apply/hq/customer/${data.bizNo}`, data);
}

// 创建联系人
export function createPersonalInfo(data) {
  return post(
    `/api/v1/common/cus/apply/hq/customer/contact/person/info/${data.bizNo}`,
    data
  );
}

// 获取个人信息
export function getPersonalInfo(bizNo) {
  return get(`/api/v1/common/cus/apply/hq/customer/info/${bizNo}`);
}

// 创建工作信息
export function createWorkInfo(data) {
  return post(`/api/v1/common/cus/apply/hq/customer/work/${data.bizNo}`, data);
}

// 获取工作信息
export function getWorkInfo(bizNo) {
  return get(`/api/v1/common/cus/apply/hq/customer/work/info/${bizNo}`);
}

// 获取联系人信息
export function getContactInfo(bizNo) {
  return get(
    `/api/v1/common/cus/apply/hq/customer/contact/person/info/${bizNo}`
  );
}

// 发起评估
export function assessVehicle(bizNo) {
  return post(`/api/v1/common/cus/apply/hq/evaluation/${bizNo}`);
}

// 车辆评估枚举
export function assessEnums() {
  return get(`/api/v1/common/cus/apply/hq/getCarEvalPicTypeList`);
}

// 发起评估v2
export function assessVehiclev2(bizNo, data) {
  return post(`/api/v1/common/cus/apply/hq/car/eval/${bizNo}`, data);
}

// 评估渠道状态
export function assessChannel(bizNo) {
  return get(`/api/v1/common/cus/apply/hq/merchant/eval/config/${bizNo}`);
}

// 车辆信息

export function vehicleInfo(bizNo) {
  return get(`/api/v1/common/cus/apply/hq/customer/vehicle/${bizNo}`);
}

// 创建车辆信息
export function createVehicleInfo(data) {
  return post(
    `/api/v1/common/cus/apply/hq/customer/vehicle/${data.bizNo}`,
    data
  );
}

// 进件材料配置
export function materialsConfigList(bizNo) {
  return get(`/api/v1/common/cus/apply/hq/${bizNo}/material/list`);
}

// 保存
export function saveMaterialsImg(data) {
  return post(`/api/v1/common/cus/apply/hq/${data.bizNo}/material`, data);
}

// 删除
export function delMaterialsImg(id) {
  return del(`/api/v1/common/cus/apply/hq/${id}/material/image`);
}

// 更改进件材料退回的状态
export function changeReturnMaterialStatus(bizNo) {
  return post(`/api/v1/common/cus/apply/hq/update/material/${bizNo}`);
}

// 预审发起
export function preExaminationApl(bizNo) {
  return post(
    `/api/v1/common/cus/apply/hq/operate/preApproval/${bizNo}`,
    null,
    null,
    null,
    {
      timeout: 300 * 1000
    }
  );
}

// 发起授信申请
export function submitApplyReq(data) {
  return post(`/api/v1/common/cus/apply/hq/credit-apply`, data, null, null, {
    timeout: 300 * 1000
  });
}

// 退回后再次发起授信申请
export function reSubmitApplyReq(data) {
  return post(`/api/v1/common/cus/apply/hq/re/credit-apply`, data, null, null, {
    timeout: 300 * 1000
  });
}

// 绑卡状态
export function bindCardStatus(bizNo) {
  return get(`/api/v1/common/cus/apply/hq/protocol/bind/card/status/${bizNo}`);
}

// 资方银行枚举
export function bankEnums() {
  return get(`/api/v1/common/cus/infra/withold/banks/hq`);
}

// 资方银行枚举
export function bankCodeEnums(data) {
  return post(`/api/v1/common/cus/apply/hq/support/bankCard/query`, {
    ...data,
    pageNo: 1,
    pageSize: 100
  });
}

// 发送验证码
export function sendBindCardSms(data) {
  return post(
    `/api/v1/common/cus/apply/hq/send/protocol/sms/${data.bizNo}`,
    data
  );
}

// 提交信息
export function bindCardSubmit(data) {
  return post(
    `/api/v1/common/cus/apply/hq/protocol/bind/card/${data.bizNo}`,
    data
  );
}

// 获取委托授权书
export function authorizationUrl(bizNo) {
  return get(`/api/v1/common/cus/apply/hq/entrusted/${bizNo}`);
}

// 删除绑卡信息
export function delCardInfo(bizNo) {
  return del(`/api/v1/common/cus/apply/hq/bank/card/bind/record/${bizNo}`);
}

// 发起征信授权
export function creditApply(data) {
  return post(`/api/v1/common/cus/apply/hq/credit/apply`, data);
}
